import * as React from "react";
import cx from "classnames";

import "./ShadowBox.css";

export interface ShadowBoxProps {
  preMatter?: string;
  postMatter?: string;
  className?: string;
  children: React.ReactChild | React.ReactChild[];
}

// TODO: Unify with Box; need to make more generic
const ShadowBox = (props: ShadowBoxProps) => (
  <div className={cx("shadow-box", props.className)}>
    {props.preMatter && (
      <p className="shadow-box__pre-matter shadow-box__matter">
        {props.preMatter}
      </p>
    )}
    {props.children}
    {props.postMatter && (
      <p className="shadow-box__post-matter shadow-box__matter">
        {props.postMatter}
      </p>
    )}
  </div>
);

export default ShadowBox;



// WEBPACK FOOTER //
// ./src/components/ShadowBox.tsx